"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ProductSkeleton = function (_a) {
    var _b = _a.skeletonCount, skeletonCount = _b === void 0 ? 30 : _b;
    var skeletons = [];
    for (var i = 0; i < skeletonCount; i++) {
        skeletons.push(react_1.default.createElement("div", { key: Math.random() * 10, className: "col-xs-6 col-md-4 col_bx_productList" },
            react_1.default.createElement("div", { className: "bx_productList skeleton" })));
    }
    return react_1.default.createElement(react_1.Fragment, null, skeletons);
};
exports.default = ProductSkeleton;
